export default __webpack_public_path__ + "img/photo-1.499c1716.jpg";